export default __webpack_public_path__ + "static/2-c9b24fd2e6367cfbe19cf2f875e587e8.jpeg";